import styled from "styled-components";
import { Box } from "../../atoms";

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacings.xs2}
    ${({ theme }) => theme.spacings.xs1};
  border-top-left-radius: ${({ theme }) => theme.borders.radius.m};
  border-top-right-radius: ${({ theme }) => theme.borders.radius.m};
  border: ${({ theme }) =>
    `${theme.borders.width.xs2} solid ${theme.colors.neutral[90]}`};
  border-bottom: none;
`;

export const Option = styled.div<{ $selected?: boolean }>`
  flex-grow: 1;
  cursor: pointer;
  user-select: none;
  padding: ${({ theme }) => theme.spacings.xs2};
  border-top: 1px solid ${({ theme }) => theme.colors.neutral[90]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[90]};

  & + & {
    border-left: ${({ theme }) => `1px solid ${theme.colors.neutral[90]}`};
  }

  &:first-child {
    border-left: 1px solid ${({ theme }) => theme.colors.neutral[90]};
    border-bottom-left-radius: ${({ theme }) => theme.borders.radius.m};
  }

  &:last-child {
    border-right: 1px solid ${({ theme }) => theme.colors.neutral[90]};
    border-bottom-right-radius: ${({ theme }) => theme.borders.radius.m};
  }

  ${({ theme, $selected }) =>
    $selected &&
    `
    && {
      border: 1px solid ${theme.colors.secondary[50]};
      background-color: ${theme.colors.secondary[95]};
    }

    & > p {
      color: ${theme.colors.secondary[50]};
    }
  `}

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary[95]};

    & > p {
      color: ${({ theme }) => theme.colors.secondary[50]};
    }
  }
`;
